import { useSource } from "@opendash/core";
import { useEffect, useState } from "react";

export interface SourceTreeSelectData {
  key: string;
  title: string;
  value: string;
  children?: SourceTreeSelectData[];
}

/**
 *
 * @returns Provides the sources a user can access in form for antd <TreeSelect /> component.<br/><br/>
 * It is hierarchical structured so that objects have a 'children' key where all children reside.
 */
export function useSourceTreeSelectData() {
  const [, , sources] = useSource();
  const [defaultData, setDefaultData] = useState<SourceTreeSelectData[]>();

  const findchildren = (id: string): SourceTreeSelectData[] => {
    return sources
      .filter((x) => {
        return x.parent ? true : false;
      })
      .filter((y) => {
        return y.parent === id;
      })
      .map((z) => {
        const name = z.name;
        return {
          key: z.id,
          title: name,
          value: z.id,
          children: findchildren(z.id),
        };
      });
  };

  useEffect(() => {
    const _data = sources
      .filter((source) => {
        return source.parent ? false : true;
      })
      .map((source): SourceTreeSelectData => {
        const name = source.name;
        return {
          key: source.id,
          title: name,
          value: source.id,
          children: findchildren(source.id),
        };
      });

    setDefaultData(_data);
  }, []);

  return defaultData;
}
